import { Progress } from 'shared';
import { ObjectValues } from 'types/common';

import { SPRINT_STATES } from 'features/sprint/config';

export const SprintInfoProgressLine = ({
  status,
  successRate,
  weekIndex,
  weeksCount,
  title,
}: {
  status: ObjectValues<typeof SPRINT_STATES>;
  successRate: number;
  weekIndex: number;
  weeksCount: number;
  title: string;
}) => {
  const progressPercentage = (weekIndex / weeksCount) * 100;
  const sprintInfoContentMap = {
    [SPRINT_STATES.ACTIVE]: {
      text: `${weekIndex}/${weeksCount}`,
      color: 'blue',
    },
    [SPRINT_STATES.FINISHED]: {
      text: `${successRate || 0}%`,
      color: 'black',
    },
  };

  return (
    <Progress
      variant="subtle"
      value={progressPercentage}
      colorPalette={sprintInfoContentMap[status]?.color || 'blue'}
      label={title}
      valueText={`Week ${sprintInfoContentMap[status]?.text}`}
      size="sm"
    />
  );
};
